import { getContentCategoryDetailsPageRoutes } from "@/modules/content-categories/routes"
import { getAppointmentsDetailPageRoutes } from "@/modules/appointments/route"
import { getEmailReportingsDetailPageRoutes } from "@/modules/email-reportings/route"
import { getConstants } from "@/logic/constants"
import { getFormDetailPageRoutes } from "@/modules/forms/route"
import { getQuestionDetailPageRoutes } from "@/modules/questions/routes"
import { getMediaLibraryFileDetailPageRoutes, getMediaLibraryFolderDetailPageRoutes } from "@/modules/media-libraries/routes"

export function getCoursesRoutes() {
  return [
    {
      path: "/courses",
      name: "courses",
      component: () => import("./views/Courses.vue"),
    },
    {
      path: "/courses/categories",
      name: "courses-categories",
      component: () => import("./views/CourseCategories.vue"),
      meta: {
        isDetailPageOutlet: true,
      },
      children: [...getContentCategoryDetailsPageRoutes(`${getConstants().MORPH_TYPES.COURSE}-content-categories`, "details")],
    },
    {
      path: "/courses/templates",
      name: "courses-templates",
      component: () => import("./course-templates/views/Index.vue"),
    },
    {
      path: "/courses/templates/manage",
      name: "courses-manage-templates",
      component: () => import("./course-templates/views/manage/Index.vue"),
    },
    {
      path: "/courses/assistant",
      name: "courses-assistant-sessions",
      component: () => import("./views/AiFlowList.vue"),
    },
    {
      path: "/courses/templates/:courseTemplateId/preview",
      name: "courses-template-preview",
      component: () => import("./course-templates/views/TemplatePreview.vue"),
    },
    {
      path: "/courses/assistant/:flowId",
      component: () => import("./views/assistant/CourseAssistantFlow.vue"),
      meta: {
        useFullHeightMainWrap: true,
        hubspotChatBottomOffset: "50px",
        isDetailPageOutlet: true,
        module: "assistant",
      },
      children: [
        {
          path: "",
          redirect: {
            name: "courses-assistant-getting-started",
          },
        },
        {
          path: "getting-started",
          name: "courses-assistant-getting-started",
          component: () => import("./views/assistant/components/AssistantFlowStartScreen.vue"),
        },
        {
          path: "baseSettings",
          name: "courses-assistant-base-settings",
          component: () => import("./views/assistant/routes/AssistantBaseSettingsRoute.vue"),
        },
        {
          path: "baseSettings/validate",
          name: "courses-assistant-base-settings-validate",
          component: () => import("./views/assistant/routes/AssistantBaseSettingsValidationRoute.vue"),
        },
        {
          path: "baseSettings/generateStructure",
          name: "courses-assistant-base-settings-generate-structure",
          component: () => import("./views/assistant/routes/AssistantStructureGenerationRoute.vue"),
          meta: {
            usesAssistantStandaloneContent: true,
          },
        },
        {
          path: "structure",
          name: "courses-assistant-structure",
          component: () => import("./views/assistant/routes/AssistantStructureRoute.vue"),
        },
        {
          path: "structure/validate",
          name: "courses-assistant-structure-validate",
          component: () => import("./views/assistant/routes/AssistantStructureValidationRoute.vue"),
        },
        {
          path: "structure/generateCourse",
          name: "courses-assistant-structure-generate-course",
          component: () => import("./views/assistant/routes/AssistantCourseGenerationRoute.vue"),
          meta: {
            usesAssistantStandaloneContent: true,
          },
        },
        ...getMediaLibraryFolderDetailPageRoutes("assistant", "folder/:folderId/medialibrary/details"),
        ...getMediaLibraryFileDetailPageRoutes("assistant", "folder/:folderId/medialibrary/files"),
      ],
    },
    {
      path: "/courses/:courseId",
      name: `course-edit/outlet`,
      component: () => import("./views/CourseEditWrapper.vue"),
      meta: {
        isDetailPageOutlet: true,
      },
      children: [
        {
          path: "contents/:chapterId?",
          name: "course-edit-contents",
          component: () => import("./views/CourseEditContents.vue"),
          meta: {
            isDetailPageParent: true,
            module: "courses",
          },
          children: [
            ...getAppointmentsDetailPageRoutes("courses", "/courses/:courseId/contents/:chapterId/:contentId/appointments"),
            ...getFormDetailPageRoutes("courses", "/courses/:courseId/contents/:chapterId/:contentId/forms"),
            ...getQuestionDetailPageRoutes("courses", "/courses/:courseId/contents/:chapterId/:contentId/questions"),
            ...getMediaLibraryFolderDetailPageRoutes("courses", "/courses/:courseId/contents/:chapterId/:contentId/folder/:folderId/medialibrary"),
            ...getMediaLibraryFileDetailPageRoutes("courses", "/courses/:courseId/contents/:chapterId/:contentId/folder/:folderId/medialibrary/files"),
          ],
        },
        {
          path: "settings",
          name: "course-edit-settings",
          component: () => import("./views/CourseEditSettings.vue"),
        },
        {
          path: "comments",
          name: `courses/course-comments`,
          component: () => import("./views/CourseComments.vue"),
          meta: {
            isDetailPage: true,
            module: "courses",
          },
        },
      ],
    },
    {
      path: "/course-statistics/:courseId",
      name: "course-statistics",
      component: () => import("./components/CourseStatisticsOld.vue"),
    },
    {
      path: "/analytics/courses/:courseId",
      name: "single-course-analytics-wrapper",
      component: () => import("./analytics/views/SingleCourseAnalyticsWrapper.vue"),
      children: [
        {
          path: "",
          name: "single-course-analytics-overview",
          component: () => import("./analytics/views/SingleCourseAnalytics.vue"),
        },
        {
          path: "participants",
          name: "single-course-analytics-participants",
          component: () => import("./analytics/views/CourseParticipantsList.vue"),
        },
        {
          path: "contents",
          name: "single-course-analytics-contents-wrapper",
          component: () => import("./analytics/views/CourseContentsWrapper.vue"),
          children: [
            {
              path: "",
              name: "single-course-analytics-contents",
              component: () => import("./analytics/views/CourseContentsList.vue"),
            },
            {
              path: ":courseContentId/forms",
              name: "single-course-analytics-contents-forms",
              component: () => import("./analytics/views/CourseFormContentUsersList.vue"),
            },
            {
              path: ":courseContentId/todolists",
              name: "single-course-analytics-contents-todolists",
              component: () => import("./analytics/views/CourseTodolistContentUsersList.vue"),
            },
            {
              path: ":courseContentId/todolists/:attemptId",
              name: "single-course-analytics-contents-todolists-attempt",
              component: () => import("./analytics/views/CourseTodolistContentAttempt.vue"),
            },
            {
              path: ":courseContentId/questions",
              name: "single-course-analytics-contents-questions",
              component: () => import("./analytics/views/CourseQuestionsContentList.vue"),
            },
            {
              path: ":courseContentId/wbt",
              name: "single-course-analytics-contents-wbt",
              component: () => import("./analytics/views/CourseWBTAnalytics.vue"),
            },
            {
              path: ":courseContentId/video-analytics",
              name: "single-course-analytics-contents-video-analytics",
              component: () => import("./analytics/views/CourseContentVideoAnalytics.vue"),
            },
          ],
        },
      ],
    },
    {
      path: "/analytics/courses/:courseId/participants/reportings",
      name: "single-course-analytics-participants-reportings",
      component: () => import("./analytics/views/CourseParticipantsListReportings.vue"),
      meta: {
        isDetailPageOutlet: true,
      },
      children: [...getEmailReportingsDetailPageRoutes("course-participant-list", "details")],
    },
    {
      path: "/analytics/courses",
      name: "courses-analytics",
      component: () => import("./analytics/views/CoursesAnalytics.vue"),
    },
    {
      path: "/analytics/courses/reportings",
      name: "courses-analytics-reportings",
      component: () => import("./analytics/views/CourseListReportings.vue"),
      meta: {
        isDetailPageOutlet: true,
      },
      children: [...getEmailReportingsDetailPageRoutes("course-analytics-list", "details")],
    },
  ]
}
